
import {
  LEAD_SUBMISSION_SUBMITTING,
  LEAD_SUBMISSION_SUCCESS,
  LEAD_SUBMISSION_ERROR,
  LEAD_SUBMISSION_RESET,
} from '../constants';

import { createLeadsSubmission } from '../../services';

// export const submitLead = (data) => ({ type: LEAD_SUBMISSION_REQUEST, data });
export const resetLead = () => ({ type: LEAD_SUBMISSION_RESET });

export const submitLead = data => { //eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: LEAD_SUBMISSION_SUBMITTING,
      request: 'request'
    });
    createLeadsSubmission(data).then((result) => {
      dispatch({
        type: LEAD_SUBMISSION_SUCCESS,
        response: result,
        dealerName: data.dealer.dealerName,
        dealerId: data.dealer.dealerId,
        dealerZipCode: data.dealer.dealerZipCode,
        optIn: data.customer.emailOptIn,
        selectedModel: data.vehicle.model

      });
      return result;
    }).catch((error) => {
      dispatch({
        type: LEAD_SUBMISSION_ERROR,
        error
      });
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/leads.js
 **/